export const saveUser = userData => {
  return {
    type: 'SAVE_USER',
    info: 'Save user data',
    payload: userData
  }
}
